module.exports = __webpack_public_path__ + "img/icon-dorm-female.14c56bbc.svg";